import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "submit-wrapper",
  class: "request-password-wrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "warning error-message"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NcButton = _resolveComponent("NcButton")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_NcButton, {
        id: "request-password-button",
        variant: "primary",
        wide: true,
        disabled: $options.isRequestInProgress,
        onClick: $options.requestPassword
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.t('spreed', 'Request password')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    ($data.hasRequestFailed)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($options.t('spreed', 'Error requesting the password.')), 1))
      : _createCommentVNode("", true)
  ], 64))
}